import { languagesData, LanguageData } from './languagesData'

function getLanguageDataById(id?: string | number | null): LanguageData | undefined {
    if (id === undefined || id === null) {
        return undefined
    }

    return languagesData[Number(id)] || undefined
}

export default getLanguageDataById
